export default __webpack_public_path__ + "images/44021f4fe8db32bf05e1081c2d7a5f6b.svg";